// @ts-strict-ignore
import { useMutation } from '@tanstack/react-query'
import {
  approvalWorkflowActionPreRequest,
  approvalWorkflowChallengeRequest,
} from 'services/ApprovalsService'
import { ApprovalWorkflowActionResponse } from 'types/approvals'
import { logSentryError } from 'utils/sentry'

export const useApprovalWorkflowActionPreRequest = () => {
  return useMutation({
    mutationFn: approvalWorkflowActionPreRequest,
    onError: (error: ApprovalWorkflowActionResponse) => {
      if (error?.status !== 428) {
        logSentryError('Error: useApprovalWorkflowActionPreRequest', error)
      }
    },
  })
}

export const useApprovalWorkflowChallengeRequest = () =>
  useMutation({ mutationFn: approvalWorkflowChallengeRequest })
